/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Guest_S3Inputs */

const en_lg_guest_s3 = /** @type {(inputs: Lg_Guest_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a call, the host selects their own active call for guests approved next. Guests choose the required media permissions before joining. **Remove** ends a visit; **Revoke link** closes the invitation.`)
};

const id_lg_guest_s3 = /** @type {(inputs: Lg_Guest_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika perlu panggilan, host memilih panggilan aktif miliknya untuk tamu yang diterima berikutnya. Tamu memilih izin media yang diperlukan sebelum bergabung. **Keluarkan** mengakhiri kunjungan; **Cabut tautan** menutup undangannya.`)
};

/**
* | output |
* | --- |
* | "For a call, the host selects their own active call for guests approved next. Guests choose the required media permissions before joining. **Remove** ends a v..." |
*
* @param {Lg_Guest_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_guest_s3 = /** @type {((inputs?: Lg_Guest_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Guest_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_guest_s3(inputs)
	return en_lg_guest_s3(inputs)
});